import { observer } from "mobx-react-lite";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import MunicipalityDetailViewModel from "viewModels/timeCharges/distributorEnums/municipalities/municipalityDetailViewModel";
import MunicipalityForm from "./municipalityForm";
import EditableDetailView from "views/common/editableDetailView";

const MunicipalityDetailView: ViewComponent<MunicipalityDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<MunicipalityForm vm={vm} />} />;
});

registerView(MunicipalityDetailView, MunicipalityDetailViewModel);
